// extracted by mini-css-extract-plugin
module.exports = {"MASK_Z_INDEX":"10000","TOAST_Z_INDEX":"20000"};